function getRuntimeWorkerUrl(): string | null {
  const runtimeWorkerUrl =
    (
      globalThis as typeof globalThis & {
        __CRAFT_FORCE_WORKER_URL?: string
      }
    ).__CRAFT_FORCE_WORKER_URL?.trim() ?? ""

  return runtimeWorkerUrl || null
}

function isLocalHost(hostname: string): boolean {
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.endsWith(".local")
  )
}

function isTestEnvironment(): boolean {
  if (typeof navigator === "undefined") return false
  return /jsdom|node\.js/iu.test(navigator.userAgent)
}

function isLocalProxyEnabled(): boolean {
  const flag = import.meta.env.PUBLIC_LOCAL_API_PROXY?.trim().toLowerCase()
  return flag === "1" || flag === "true"
}

export function getApiBaseUrl(): string | null {
  const runtimeWorkerUrl = getRuntimeWorkerUrl()
  if (runtimeWorkerUrl) return runtimeWorkerUrl

  const workerUrl = import.meta.env.PUBLIC_WORKER_URL?.trim()
  if (workerUrl) return workerUrl

  if (typeof window === "undefined") return null

  const { hostname, origin } = window.location
  if (!isTestEnvironment() && isLocalHost(hostname) && !isLocalProxyEnabled()) {
    return null
  }

  return origin
}

export function getWsBaseUrl(): string {
  const workerUrl = import.meta.env.PUBLIC_WORKER_URL?.trim()
  if (workerUrl) {
    return workerUrl.replace(/^https/, "wss").replace(/^http/, "ws")
  }

  const proto = window.location.protocol === "https:" ? "wss" : "ws"
  return `${proto}://${window.location.host}`
}
